import script from "./MoleculeModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeModal.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeModal.vue?vue&type=style&index=0&id=24173331&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24173331"]])

export default __exports__